import type { Shape } from "./types";

export const SHAPES: Shape[] = [
  {
    id: "circle",
    name: "Orb",
    svg: '<circle cx="50" cy="50" r="38" fill="currentColor"/>',
  },
  {
    id: "triangle",
    name: "Spike",
    svg: '<polygon points="50,10 90,82 10,82" fill="currentColor"/>',
  },
  {
    id: "square",
    name: "Block",
    svg: '<rect x="14" y="14" width="72" height="72" rx="6" fill="currentColor"/>',
  },
  {
    id: "diamond",
    name: "Diamond",
    svg: '<polygon points="50,10 90,50 50,90 10,50" fill="currentColor"/>',
  },
  {
    id: "hexagon",
    name: "Hex",
    svg: '<polygon points="50,8 88,30 88,70 50,92 12,70 12,30" fill="currentColor"/>',
  },
  {
    id: "pentagon",
    name: "Penta",
    svg: '<polygon points="50,10 90,40 75,86 25,86 10,40" fill="currentColor"/>',
  },
  {
    id: "star",
    name: "Star",
    svg: '<polygon points="50,8 61,38 92,38 67,57 76,88 50,70 24,88 33,57 8,38 39,38" fill="currentColor"/>',
  },
  {
    id: "cross",
    name: "Cross",
    svg: '<rect x="40" y="10" width="20" height="80" fill="currentColor"/><rect x="10" y="40" width="80" height="20" fill="currentColor"/>',
  },
  {
    id: "heart",
    name: "Heart",
    svg: '<path d="M50 86 C20 60 14 36 30 22 C40 14 50 24 50 32 C50 24 60 14 70 22 C86 36 80 60 50 86 Z" fill="currentColor"/>',
  },
  {
    id: "arrow",
    name: "Arrow",
    svg: '<polygon points="18,38 58,38 58,18 92,50 58,82 58,62 18,62" fill="currentColor"/>',
  },
  {
    id: "crescent",
    name: "Moon",
    svg: '<path d="M50 12 A 38 38 0 1 0 50 88 A 38 38 0 1 0 50 12 Z M58 20 A 30 30 0 1 1 58 80 A 30 30 0 1 1 58 20 Z" fill="currentColor" fill-rule="evenodd"/>',
  },
  {
    id: "bolt",
    name: "Bolt",
    svg: '<polygon points="55,8 25,55 45,55 35,92 75,42 50,42 65,8" fill="currentColor"/>',
  },
  {
    id: "drop",
    name: "Drop",
    svg: '<path d="M50 8 C50 8 22 48 22 65 C22 80 35 92 50 92 C65 92 78 80 78 65 C78 48 50 8 50 8 Z" fill="currentColor"/>',
  },
  {
    id: "sparkle",
    name: "Sparkle",
    svg: '<path d="M50 6 L56 44 L94 50 L56 56 L50 94 L44 56 L6 50 L44 44 Z" fill="currentColor"/>',
  },
  {
    id: "ring",
    name: "Ring",
    svg: '<path d="M50 12 A 38 38 0 1 0 50 88 A 38 38 0 1 0 50 12 Z M50 28 A 22 22 0 1 1 50 72 A 22 22 0 1 1 50 28 Z" fill="currentColor" fill-rule="evenodd"/>',
  },
  {
    id: "flower",
    name: "Bloom",
    svg: '<circle cx="50" cy="22" r="16" fill="currentColor"/><circle cx="50" cy="78" r="16" fill="currentColor"/><circle cx="22" cy="50" r="16" fill="currentColor"/><circle cx="78" cy="50" r="16" fill="currentColor"/><circle cx="50" cy="50" r="14" fill="currentColor"/>',
  },
];
